module.exports = __webpack_public_path__ + "static/media/icon.c9d023cf.png";